import React from 'react';
import { cn } from '../../lib/utils';

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  container?: boolean;
  background?: 'white' | 'gray' | 'blue';
}

export const Section = React.forwardRef<HTMLElement, SectionProps>(
  ({ className, container = true, background = 'white', children, ...props }, ref) => {
    return (
      <section
        ref={ref}
        className={cn(
          'py-16 md:py-24',
          {
            'bg-white': background === 'white',
            'bg-neutral-light': background === 'gray',
            'bg-primary text-white': background === 'blue',
          },
          className
        )}
        {...props}
      >
        {container ? (
          <div className="container mx-auto px-4 md:px-6">{children}</div>
        ) : (
          children
        )}
      </section>
    );
  }
);

Section.displayName = 'Section';
